import React, { Fragment, Component } from 'react';
import { Container, Row, Col, Card, CardBody, CardTitle, CardSubtitle, Spinner, Button, Tooltip } from 'reactstrap';
import FeatherIcon from "feather-icons-react";
import apiResponse from '../../../../../services/apiResponse'
import StatCardsComponent from './StatCardsComponent';
import PredicateLegend from './PredicateLegend';
import Table360Component from './Table360Component';
import ModalDetail from '../../Detail/ModalDetail';
import PenilaianBloc from "../Blocs/PenialianBloc"
import { config } from "../../../../../helpers/config_global"
import MKIDatatable from '../../../../../modules/mki-datatable/lib'
import { cancelToken } from "../../../../../services/adapters/master/penialian360Service"
import { Link, useHistory, Redirect } from "react-router-dom"
import '../../custom360.css';
import moment from "moment"
import 'moment/locale/id'
import * as XLSX from 'xlsx'; 

class DetailPeriodComponent extends Component {

  penilaianBloc = new PenilaianBloc();

  source
    historyTable = 'recapDataTable360Active'
    defaultOrder = 'ms360_team_member_id'
    defaultSize = 10
    defaultSort = 'desc'
    configDatatable = {
        ...config('datatable'),
        sort: {
            column: this.defaultOrder,
            order: this.defaultSort
        }
    }

    constructor(props) {
        super(props);

        const savedFilter = sessionStorage.getItem(this.historyTable);

        let filter = {
            filter_value: "",
            page_number: 1,
            page_size: this.defaultSize,
            sort_order: {
                column: this.defaultOrder,
                order: this.defaultSort
            }
        };

        if (savedFilter) {
            try {
                filter = JSON.parse(savedFilter);
            } catch (error) {
                console.error("Invalid sessionStorage filter:", savedFilter);
                sessionStorage.removeItem(this.historyTable);
            }
        }

        this.state = {
            loadingDownload: false,
            detailUuid: null,
            breakDown: {},
            period: {},
            work_unit: {},
            redirectBack: false,
            loadingContent: true,
            activePredicateFilter: null,
            isModalOpen: false,
            selectedDetailData: null,
            isDetailLoading: false,
            tooltip: false,
            rows: [],
            totalRow: 0,
            loadingTable: true,
            filter: filter,
            categories: [
              { id: 'all', label: 'Semua', color: '#fff', bg: '#1e3a8a', border: '#1e40af' },
              { id: 'sangat-kurang', label: 'Sangat Kurang', color: '#dc2626', bg: '#fef2f2', border: '#f87171' },
              { id: 'kurang', label: 'Kurang', color: '#d97706', bg: '#fffbeb', border: '#f59e0b' },
              { id: 'butuh-perbaikan', label: 'Cukup', color: '#ca8a04', bg: '#fefce8', border: '#eab308' },
              { id: 'baik', label: 'Baik', color: '#0284c7', bg: '#f0f9ff', border: '#38bdf8' },
              { id: 'sangat-baik', label: 'Sangat Baik', color: '#16a34a', bg: '#f0fdf4', border: '#4ade80' },
            ],
            activeFilter: 'all'
        };

        this.toggleModal = this.toggleModal.bind(this);
        this.handleSelectFilter = this.handleSelectFilter.bind(this);
        this.handleBack = this.handleBack.bind(this);
    }

  toggleModal() {
    this.setState((prevState) => ({ isModalOpen: !prevState.isModalOpen }));
  }

  handleSelectFilter(catId) {
    this.setState({ activePredicateFilter: catId });
  }

  loadData = async () => {
    const queryParams = new URLSearchParams(window.location.search);
    const period_uuid = queryParams.get('uuid')
    const team_uuid = queryParams.get("team_uuid")
    await this.penilaianBloc.fetchRecapDetailPeriod({ period_uuid: period_uuid, team_uuid: team_uuid  })
  }

  onSelectFilter = (elem) => {
    this.setState({ activeFilter: elem })
    setTimeout(() => { 
       this.setTokenAPI()
    }, 500)
  }

  componentDidMount() {

    this.loadData()

    this.penilaianBloc.recapDownloadChannel.subscribe((result) => {
        switch (result.status) {
            case apiResponse.INITIAL:
                this.setState({
                    loadingDownload: false
                })
                break
            case apiResponse.LOADING:
                this.setState({
                    loadingDownload: true
                })
                break
            case apiResponse.COMPLETED:
                const response = result.data.response
                this.handleDownload(response.result)
                this.setState({
                    loadingDownload: false
                })
                break
            case apiResponse.ERROR:
                this.setState({
                    loadingDownload: false
                })
                break
            default:
                break
        }
    })

    this.penilaianBloc.recapPeriodDetailChannel.subscribe((result) => {
        switch (result.status) {
            case apiResponse.INITIAL:
                this.setState({
                    loadingContent: false
                })
                break
            case apiResponse.LOADING:
                this.setState({
                    loadingContent: true
                })
                break
            case apiResponse.COMPLETED:
                const response = result.data.response
                this.setState({
                    loadingContent: false,
                    period: response.period,
                    work_unit: response.work_unit
                })
                this.setTokenAPI()
                break
            case apiResponse.ERROR:
                
                break
            default:
                break
        }
    })

    this.penilaianBloc.recapDataTableChannel.subscribe((result) => {
        switch (result.status) {
            case apiResponse.INITIAL:
                this.setState({
                    loadingTable: false
                })
                break
            case apiResponse.LOADING:
                this.setState({
                    loadingTable: true
                })
                break
            case apiResponse.COMPLETED:
                const response = result.data.response
                const rows = response.result

                this.setState({
                    totalRow: response.total,
                    rows: rows,
                    loadingTable: false
                })
                break
            case apiResponse.ERROR:
                
                break
            default:
                break
        }
    })


  }

  componentWillUnmount(){
    this.penilaianBloc.recapPeriodDetailChannel.unsubscribe()
    this.penilaianBloc.recapDataTableChannel.unsubscribe()
  }

  handleBack(e) {
    this.setState({
        redirectBack: true
    })
  }

  renderPredikatBadge = (predikat, predikatId) => {
    if (!predikat || predikat === '-') {
      return <span>-</span>;
    }

    const badgeClass = predikatId || predikat.toLowerCase().replace(/\s+/g, '-');
    return <span className={`p360-badge ${badgeClass}`}>{predikat}</span>;
  }

  slugify = (text) => {
     return text
        .toString()                     // Ensure it's a string
        .toLowerCase()                  // Convert to lowercase
        .trim()                         // Remove spaces from both ends
        .normalize('NFD')               // Split accented characters into their base letters and diacritics
        .replace(/[\u0300-\u036f]/g, '') // Remove diacritics (accents)
        .replace(/[^a-z0-9 -]/g, '')    // Remove invalid characters
        .replace(/\s+/g, '-')           // Replace spaces with hyphens
        .replace(/-+/g, '-');
  }

  columns = [
    {
        key: "nip",
        text: "NIP",
        className: "nip",
        sortable: true,
    },
    {
        key: "nama",
        text: "Nama Pegawai",
        className: "nama",
        sortable: true,
    },
    {
        key: "jabatan",
        text: "Jabatan",
        className: "jabatan",
        sortable: true,
    },
    {
        key: "nilai_total",
        text: "Nilai Total",
        className: "nilai_total",
        sortable: false,
        align: 'center',
        cell: record => {
             let item = {
                predikat: '',
                predikat_id: ''
            }
            const score = parseFloat(record?.nilai_total)
            if (score >= 90) {
                item.predikat = 'Sangat Baik';
                item.predikat_id = 'sangat-baik';
            } else if (score >= 80) {
                item.predikat = 'Baik';
                item.predikat_id = 'baik';
            } else if (score >= 70) {
                item.predikat = 'Cukup';
                item.predikat_id = 'butuh-perbaikan';
            } else if (score >= 60) {
                item.predikat = 'Kurang';
                item.predikat_id = 'kurang';
            } else {
                item.predikat = 'Sangat Kurang';
                item.predikat_id = 'sangat-kurang';
            }
            return (
                <>
                    <div className='d-block mb-2'>
                        <div className={`p360-badge ${item.predikat_id}`}>
                            {/* {parseFloat(record?.nilai_total).toFixed(2)} */}
                            {Math.round(parseFloat(record?.nilai_total) || 0)}
                        </div>
                    </div>
                     <div className='d-block'>
                       {this.renderPredikatBadge(item.predikat, item.predikat_id )}
                    </div>
                </>
            )
        }
    },
     {
        key: "nilai_total_ahlak",
        text: "Nilai BerAKHLAK",
        className: "nilai_total_ahlak",
        sortable: false,
        align: 'center',
        cell: record => {
             let item = {
                predikat: '',
                predikat_id: ''
            }
            const score = parseFloat(record?.nilai_total_ahlak)
            if (score >= 90) {
                item.predikat = 'Sangat Baik';
                item.predikat_id = 'sangat-baik';
            } else if (score >= 80) {
                item.predikat = 'Baik';
                item.predikat_id = 'baik';
            } else if (score >= 70) {
                item.predikat = 'Cukup';
                item.predikat_id = 'butuh-perbaikan';
            } else if (score >= 60) {
                item.predikat = 'Kurang';
                item.predikat_id = 'kurang';
            } else {
                item.predikat = 'Sangat Kurang';
                item.predikat_id = 'sangat-kurang';
            }
            return (
                <>
                    <div className='d-block mb-2'>
                        <div className={`p360-badge ${item.predikat_id}`}>
                            {/* {parseFloat(record?.nilai_total_ahlak).toFixed(2)} */}
                            {Math.round(parseFloat(record?.nilai_total_ahlak) || 0)}
                        </div>
                    </div>
                     <div className='d-block'>
                        {this.renderPredikatBadge(item.predikat, item.predikat_id )}
                    </div>
                </>
            )
        }
    },
    {
        key: "action",
        text: "AKSI",
        className: "action",
        width: 120,
        sortable: false,
        align: 'center',
        cell: record => {
            const thisId = record.uuid;
            return (
                <Fragment>
                    <span>
                        <button 
                            className="btn btn-success btn-sm" 
                            id={"detail-" + thisId}
                            onClick={() => {
                                this.setState({
                                    detailUuid: record.uuid
                                })
                            }}
                            style={{
                                marginRight: '2px',
                                padding: '2px 5px'
                            }}>
                            <i className="uil-search"></i>
                        </button>
                        <Tooltip
                            style={{
                                marginBottom: 2
                            }}
                            placement="top" isOpen={this.state["detail" + thisId]} target={"detail-" + thisId}
                            toggle={() => {
                                this.setState({
                                    ["detail" + thisId] : !this.state["detail" + thisId]
                                })
                            }}
                        >Lihat Detail</Tooltip>
                    </span>
                </Fragment>
            )
        }
    }
  ]

   toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });

   loadDataTable = async () => {
        /* history Datatable */
        sessionStorage.setItem(this.historyTable, JSON.stringify(this.state.filter))

        /* kirim ke server */
        let offset = (this.state.filter.page_number-1)*this.state.filter.page_size
        if(this.state.defaultSize!==this.state.filter.page_size) {
            this.setState({
                defaultSize: this.state.filter.page_size
            })
            offset = 0
            this.configDatatable.page_number = 1
        }
        const queryParams = new URLSearchParams(window.location.search);
        const period_uuid = queryParams.get('uuid')
        const team_uuid = queryParams.get("team_uuid")
        const query = {
            search: this.state.filter.filter_value,
            limit: this.state.filter.page_size,
            offset: offset,
            order: this.state.filter.sort_order.column,
            sort: this.state.filter.sort_order.order,
            period_uuid: period_uuid,
            team_uuid: team_uuid,
            filter: this.state.activeFilter,
            status: 1

        }
        await this.penilaianBloc.fetchDataTable(query, this.source.token)
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadDataTable()
    }

    handleExcel = async () => {
        const queryParams = new URLSearchParams(window.location.search);
        const period_uuid = queryParams.get('uuid')
        const team_uuid = queryParams.get("team_uuid")
        const query = {
            period_uuid: period_uuid,
            team_uuid: team_uuid
        }
        await this.penilaianBloc.fetchRecapDownload(query)
    }

    buildSheet = (aoa) => {
        const worksheet = XLSX.utils.aoa_to_sheet(aoa);

        const colCount = aoa[0].length;

        worksheet["!cols"] = Array.from(
            { length: colCount },
            (_, colIndex) => {
                const maxLength = Math.max(
                    ...aoa.map((row) => {
                        const value = row[colIndex];
                        return value == null ? 0 : String(value).length;
                    })
                );

                return {
                    wch: maxLength + 2,
                };
            }
        );

        // Header style
        for (let colIndex = 0; colIndex < colCount; colIndex++) {
            const cellRef = XLSX.utils.encode_cell({
                r: 0,
                c: colIndex,
            });

            if (worksheet[cellRef]) {
                worksheet[cellRef].s = {
                    fill: {
                        patternType: "solid",
                        fgColor: { rgb: "111111" }
                    }
                };
            }
        }

        return worksheet;
    };

    handleDownload = (rows) => {

       if (!rows || rows.length === 0) {
            console.warn("handleDownload: no rows to export");
            return;
        }

        const REF_NILAI = [
            ["Kuadran", "Nilai"],
            ["Sangat Baik", 5],
            ["Baik", 4],
            ["Cukup", 3],
            ["Kurang", 2],
            ["Sangat Kurang", 1],
        ];

        const REF_PENILAI = [
            ["Peranan", "Kode"],
            ["Atasan", 10],
            ["Sejawat", 20],
            ["Bawahan", 30],
        ];

        const headers = [
            "NIP",
            "Peran Penilai",
            "Berorientasi Pelayanan",
            "Akuntable",
            "Kompeten",
            "Harmonis",
            "Loyal",
            "Adaftif",
            "Kolaboratif",
        ];

        const ucfirst = (str) => {
            if (!str) return str;
            return str.charAt(0).toUpperCase() + str.slice(1);
        };

        const getNilai = (num) => {
            const score = parseInt(num)
            if (score >= 90) {
               return "Sangat Baik";
            } else if (score >= 80) {
                return "Baik";
            } else if (score >= 70) {
                return "Cukup";
            } else if (score >= 60) {
               return "Kurang";
            } else {
               return "Sangat Kurang";
            }
        }

        const indexPeran = (m) => {
            if(m === 'atasan'){
                return 10;
            }else if(m === 'sejawat'){
                return 20
            }else{
                return 30
            }
        }

        const data = rows.map((r) => [
            r.nip,
            // indexPeran(r.peran),
            // parseFloat(r.orientasi_layanan).toFixed(2),
            // parseFloat(r.akuntable).toFixed(2),
            // parseFloat(r.kompoeten).toFixed(2),
            // parseFloat(r.harmonis).toFixed(2),
            // parseFloat(r.loyal).toFixed(2),
            // parseFloat(r.adaptif).toFixed(2),
            // parseFloat(r.kolaboartif).toFixed(2),
            Math.round(indexPeran(r.peran) || 0),
            Math.round(parseFloat(r.orientasi_layanan) || 0),
            Math.round(parseFloat(r.akuntable) || 0),
            Math.round(parseFloat(r.kompoeten) || 0),
            Math.round(parseFloat(r.harmonis) || 0),
            Math.round(parseFloat(r.loyal) || 0),
            Math.round(parseFloat(r.adaptif) || 0),
            Math.round(parseFloat(r.kolaboartif) || 0),
        ]);

        const workbook = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(
            workbook,
            this.buildSheet([headers, ...data]),
            "data"
        );
        XLSX.utils.book_append_sheet(
            workbook,
            this.buildSheet(REF_NILAI),
            "ref_nilai"
        );
        XLSX.utils.book_append_sheet(
            workbook,
            this.buildSheet(REF_PENILAI),
            "ref_penilai"
        );

        const now = new Date();
        const pad = (n) => String(n).padStart(2, "0");
        const timestamp =
            `${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}_` +
            `${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}`;

        XLSX.writeFile(workbook, `rekap_penilaian_360_${timestamp}.xlsx`);
    }


  render() {
    const { activePredicateFilter, isModalOpen, selectedDetailData, isDetailLoading } = this.state;
    const queryParams = new URLSearchParams(window.location.search);
    const period_uuid = queryParams.get('uuid')
    return (
      <Fragment>
        { this.state.loadingContent ? <>
            <div className='card'>
                <div className='card-body p-5 text-center'>
                    <Spinner size="sm" className="me-1" />
                    Memuat Data...
                </div>
            </div>
        </> : <>
            <Container fluid>
                <Row>
                  <Col xs="12">
                    {/* Page Title & Subtitle */}
                    <div className="mb-3 card p-4">
                       <div className='clearfix'>
                          <div className='float-start'>
                            <CardTitle className="h4 mb-1">Rekap Penilaian 360°</CardTitle>
                            <CardSubtitle className="text-muted mb-0">
                               <p className="text-muted mt-2">
                                {this.state.work_unit?.work_unit_name} ({`Periode : ${moment(this.state.period.ms360_period_date_start).format('DD MMMM YYYY')} s/d ${moment(this.state.period.ms360_period_date_end).format('DD MMMM YYYY')}`})
                              </p>
                              Pantau progres dan hasil penilaian kompetensi pegawai berdasarkan penilaian dari berbagai pihak.
                            </CardSubtitle>
                          </div>
                          <div className='float-end'>
                              <Button type="button" onClick={this.handleBack} className="pn-btn-outline btn-danger">
                                <FeatherIcon icon="arrow-left" size="16" />
                                  <span className="ms-2">Kembali</span>
                              </Button>
                               <Button type="button" onClick={this.handleExcel} disabled={this.state.loadingDownload} className="pn-btn-outline btn-success ms-2">
                                  { this.state.loadingDownload ? <>
                                    <Spinner size="sm" className="me-1" />
                                    Sedang Generate Data...
                                </> : <>  <FeatherIcon icon="file" size="16" /><span className="ms-2"> Download</span></> }
                              </Button>
                          </div>
                       </div>
                    </div>

                    {/* Top KPI Stat Cards */}
                    <StatCardsComponent />

                    {/* Main Card */}
                    <Card className="border-0 shadow-sm" style={{ borderRadius: '14px' }}>
                      <CardBody className="p-4">
                          <div className="p360-legend-wrapper mb-4">
                            <span className="p360-legend-title">Kategori Predikat:</span>
                            {this.state.categories.map((cat) => {
                              const isSelected = this.state.activeFilter === cat.id;
                              return (
                                <button
                                  key={cat.id}
                                  type="button"
                                  className={`p360-badge ${cat.id}`}
                                  onClick={() => this.onSelectFilter && this.onSelectFilter(isSelected ? null : cat.id)}
                                  style={{
                                    cursor: this.onSelectFilter ? 'pointer' : 'default',
                                    transform: isSelected ? 'scale(1.05)' : 'none',
                                    boxShadow: isSelected ? `0 0 0 2px ${cat.color}` : 'none',
                                  }}
                                >
                                  <span className="p360-dot"></span>
                                  {cat.label}
                                </button>
                              );
                            })}
                          </div>
                          <MKIDatatable
                              className={this.configDatatable.tableClass}
                              config={this.configDatatable}
                              records={this.state.rows}
                              columns={this.columns}
                              dynamic={true}
                              minWidth={1000}
                              total_record={this.state.totalRow}
                              initial={this.state.filter}
                              onChange={(filter) => {
                                  this.setState({
                                      loadingTable: true,
                                      filter: filter
                                  }, function () {
                                      this.setTokenAPI()
                                  });
                              }}
                              loading={this.state.loadingTable}
                          />
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </Container>

              {/* Modal Detail Breakdown */}
              
              </> }
          { this.state.redirectBack ?
            <Redirect to={`/kepegawaian/rekap360.html`} />
        : null }
         { this.state.detailUuid !== null && this.state.detailUuid !== '' ?
            <Redirect to={"/kepegawaian/rekap360.html?section=assessment&uuid=" + this.state.detailUuid}/>
        : null }
      </Fragment>
    );
  }
}

export default DetailPeriodComponent;